export default "__VITE_ASSET__04c876d2__"